export default {
  data() {
    return {
      exportarDisabled: false
    };
  },

  methods: {
    async exportarRelatorio() {
      this.exportarDisabled = true;

      try {
        const response = await this.axios.post(
          this.$urls.EXPORTAR_CENTROS_CUSTOS,
          this.filters
        );

        if (response.status !== 200) {
          this.$notify.error({
            title: "Exportar Centro de Custo",
            message: `Não foi possível Exportar o Centro de Custo`,
            position: "top-left"
          });
          return;
        }

        this.exibirNotificacaoSucesso();
      } catch (error) {
        this.tratarErroExportacao(error);
      } finally {
        this.exportarDisabled = false;
      }
    },

    exibirNotificacaoSucesso() {
      this.$notify({
        type: "success",
        title: "Gerando Relatório",
        dangerouslyUseHTMLString: true,
        message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
      });
    },

    tratarErroExportacao(error) {
      this.$message.error("Erro ao exportar relatório");
      console.error(error);
    }
  }
};
